import { useLocale } from "@custom/schema";
import { AnimatePresence, useReducedMotion } from "framer-motion";
import React from "react";
import { IntlProvider } from "react-intl";
import { translations, TranslationsProvider } from "../../utils/translations";
import { Footer } from "../Organisms/Footer";
import { Header } from "../Organisms/Header";
function useTranslations() {
    var locale = useLocale();
    return translations[locale];
}
export function Frame(props) {
    var locale = useLocale();
    var translations = useTranslations();
    return /*#__PURE__*/ React.createElement(IntlProvider, {
        locale: locale,
        messages: translations
    }, /*#__PURE__*/ React.createElement(TranslationsProvider, null, /*#__PURE__*/ React.createElement("div", {
        className: "full-height flex flex-col overflow-auto"
    }, /*#__PURE__*/ React.createElement(Header, null), /*#__PURE__*/ React.createElement("main", {
        className: "flex flex-col 2xl:flex-grow-[4] flex-auto relative"
    }, useReducedMotion() ? /*#__PURE__*/ React.createElement(React.Fragment, null, props.children) : /*#__PURE__*/ React.createElement(AnimatePresence, {
        mode: "wait",
        initial: false
    }, props.children)), /*#__PURE__*/ React.createElement(Footer, null))));
}
